/**
 * Puts betweenItem between items
 */
export function intersperse<T>(items: T[], betweenItem: T): T[] {
    return items
        .map((item, i) => (i < items.length - 1 ? [item, betweenItem] : [item]))
        .flatMap((item) => item);
}
